import React, { useState, useEffect } from 'react';
import { Card, makeStyles, Typography } from '@material-ui/core';
import TransactionTable from './TransactionTable';

const TransactionListCard = ({transactions, loading, total, tableFilter, onChangeTablePagination}) => {

    const classes = useStyles()
    const [data, setData] = useState([])
    //const [total, setTotal] = useState(0)
    //const [tableFilter, setTableFilter] = useState({limit:20,offset:0})


    useEffect(() => {
        const {limit, offset} = tableFilter
        //let _data = []
        if(transactions){
            //_data = transactions.slice(offset*limit, offset*limit + limit)
            setData(transactions)
        } 
        //setTotal(transactions.length)
    }, [transactions, tableFilter])

    const onUpdateTableFilter = (data) => {
        console.log(data)
        onChangeTablePagination(data)
    }

    return ( 
        <div>
            <Typography className={classes.title}>Transaction Details</Typography>
            <div className={classes.card}>
                <TransactionTable data={data} loading={loading}
                total={total} tableFilter={tableFilter} onUpdateTableFilter={onUpdateTableFilter}/>
            </div>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    title:{
        fontWeight:700,
        color:theme.palette.primary.main,
        fontSize:24,
        marginBottom:16
    },
    card:{
        //boxShadow:'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        borderRadius:8,
    }
}))
 
export default TransactionListCard;